import React, { useState } from 'react';
import logoWhite from '../assets/images/logos/VITAE GUITARS FINAL LOGO WHITE NO GUITARS.png';
import logoBlack from '../assets/images/logos/VITAE GUITARS FINAL LOGO BLACK.png';

const Header = ({ isScrolled, activeNav, setActiveNav }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems = [
    { name: 'Featured', id: 'featured' },
    { name: 'About', id: 'about' },
    { name: 'Models', id: 'models' },
    // { name: 'Builder', external: true, url: '/builder' },
    { name: 'Artists', id: 'artists' },
    { name: 'Gallery', id: 'gallery' },
    { name: 'Contact', id: 'contact' },
    { name: 'Merch', external: true, url: 'https://vitaeguitars.threadless.com/' }
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavClick = (item) => {
    if (item.external) {
      if (item.url.startsWith('/')) {
        // Internal page navigation
        window.history.pushState({}, '', item.url);
        window.dispatchEvent(new PopStateEvent('popstate'));
        setIsMobileMenuOpen(false);
      } else {
        // External link
        window.open(item.url, '_blank');
      }
    } else {
      setActiveNav(item.id);
      setIsMobileMenuOpen(false); // Close mobile menu on click
      
      // Smooth scroll to section
      const element = document.getElementById(item.id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };
  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-in-out ${
      isScrolled || (isMobileMenuOpen && window.innerWidth < 768)
        ? 'bg-theme-bg-glass backdrop-blur-md border-b border-white/5 shadow-lg py-2'
        : 'bg-transparent border-b border-transparent py-4'
    }`}>
      <div className="container mx-auto px-6">
        <div className="flex justify-between items-center">
          <div className="text-3xl font-bold tracking-wider">
            <a href="#" className="text-theme-text-primary hover:text-theme-primary-400 transition-colors flex items-center gap-3 group">
              <img 
                src={logoWhite} 
                alt="Vitæ Guitars Logo" 
                className="h-10 w-auto flex-shrink-0 transition-transform duration-300 group-hover:scale-105"
              />
              <span className="text-2xl font-bold tracking-[0.2em] hidden sm:inline md:hidden lg:inline">Vitæ Guitars</span>
            </a>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigationItems.map((item) => (
              <button 
                key={item.id || item.name} 
                onClick={() => handleNavClick(item)}
                className={`relative text-theme-text-primary hover:text-theme-primary-400 transition-colors text-sm uppercase tracking-[0.15em] font-medium cursor-pointer whitespace-nowrap py-2 group ${
                  activeNav === item.id ? 'text-theme-primary-400' : ''
                }`}
              >
                {item.name}
                <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-theme-primary-400 transform origin-left transition-transform duration-300 ${
                  activeNav === item.id ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                }`}></span>
              </button>
            ))}
          </nav>
          
          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white focus:outline-none cursor-pointer !rounded-button whitespace-nowrap p-2 hover:bg-white/10 transition-colors rounded-lg"
            onClick={toggleMobileMenu}
          >
            <i className={`fas text-xl transition-transform duration-300 ${
              isMobileMenuOpen ? 'fa-times rotate-90 text-theme-primary-400' : 'fa-bars'
            }`}></i>
          </button>
        </div>
        
        {/* Mobile Navigation Menu */}
        <div className={`md:hidden transition-all duration-500 ease-in-out overflow-hidden ${
          isMobileMenuOpen ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0 mt-0'
        }`}>
          <div className="bg-theme-bg-card/95 backdrop-blur-xl rounded-xl border border-white/10 shadow-2xl overflow-hidden">
          <nav className="flex flex-col py-2">
            {navigationItems.map((item) => (
              <button 
                key={item.id || item.name}
                onClick={() => handleNavClick(item)}
                className={`block w-full text-left py-4 px-6 text-theme-text-primary hover:text-theme-primary-400 hover:bg-white/5 transition-all text-sm uppercase tracking-wider font-medium cursor-pointer border-b border-white/5 last:border-0 ${
                  activeNav === item.id ? 'text-theme-primary-400 bg-white/5 border-l-4 border-l-theme-primary-400' : 'border-l-4 border-l-transparent'
                }`}
              >
                {item.name}
                {item.external && <i className="fas fa-external-link-alt ml-2 text-xs opacity-50"></i>}
              </button>
            ))}
          </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
